import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import * as Parse from 'parse';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  currentLoginStatus = new BehaviorSubject<boolean>(false);

  constructor() { }

  isUserLoggedIn() {
    return Parse.User.currentAsync().then(user => {
      if(user) {
        this.currentLoginStatus.next(true);
        return true;
      } else {
        this.currentLoginStatus.next(false);
        return false;
      }
    }, err => {
      console.log('Request Failed - Not Logged In');
      this.currentLoginStatus.next(false);
      return false;
    });
  }

  getCurrentUser() {
    return Parse.User.current();
  }

  logOut() {
    return from(Parse.User.logOut().then((user) => {
      this.currentLoginStatus.next(false);
    }, (err) => {
      console.log('Something went wrong!');
    }));
  }
}
